/* Publish by EComposer at 2026-10-11 09:29:22*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-93njtjr318"]=  window.__ectimmers["ecom-93njtjr318"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-93njtjr318').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93njtjr318', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8z2w598ojd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8z2w598ojd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-376mvox6kqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-376mvox6kqa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nnl9q8wolob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nnl9q8wolob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5z3hks85sa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5z3hks85sa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tkb3f7sj44').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tkb3f7sj44', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kx014ebr5x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kx014ebr5x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zpmftwmheam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zpmftwmheam', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gjhh5pv1jqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gjhh5pv1jqk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rtvwte32upo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rtvwte32upo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wabmurj5nv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wabmurj5nv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kvvn4qinns9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvvn4qinns9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ztq5bu27x6s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ztq5bu27x6s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yw0xusmp7gk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yw0xusmp7gk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bfwcihxs3yw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfwcihxs3yw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46rurmp37nq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46rurmp37nq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5vhzbefx5bp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5vhzbefx5bp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-trbqf2dx28d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-trbqf2dx28d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rgt0c6n5qej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rgt0c6n5qej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zwty7twog19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zwty7twog19', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ld3kwxu4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ld3kwxu4e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wmvx0m9zu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wmvx0m9zu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qlr5egf2zoa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qlr5egf2zoa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-no3nu3rvk7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-no3nu3rvk7i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ps7k0vqx5lc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ps7k0vqx5lc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qrxz4dobrj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qrxz4dobrj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0boxz0uwoep5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0boxz0uwoep5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oexb6qy6m4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oexb6qy6m4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxl4nxheiy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxl4nxheiy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t81ux5nyow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t81ux5nyow', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ri192zifuw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ri192zifuw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxizub2ir5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxizub2ir5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nvpi689shx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nvpi689shx8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-necaw6l6ml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-necaw6l6ml', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3acm7zblsh7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3acm7zblsh7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmej128xpsf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmej128xpsf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4zbqporit').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4zbqporit', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-n0zcui1uy5"]=  window.__ectimmers["ecom-n0zcui1uy5"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-n0zcui1uy5"]["3pv0bmqu5"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-n0zcui1uy5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n0zcui1uy5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2dcqa6ao1gs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2dcqa6ao1gs', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-83y96u803p3"]=  window.__ectimmers["ecom-83y96u803p3"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-83y96u803p3"]["tsajeiqa7"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-83y96u803p3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-83y96u803p3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3l3bof0q2ie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3l3bof0q2ie', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oqahlg1d1z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqahlg1d1z', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fl4fml8msgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fl4fml8msgh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-plxoenr8nf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-plxoenr8nf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-alfsjx2kayu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-alfsjx2kayu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jn5afgb38do').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jn5afgb38do', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lz7r1qqo63').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lz7r1qqo63', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-576uqlo92kw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-576uqlo92kw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}